import { render } from "./ThreeAxleTractorTwoAxleSemitrailer.vue?vue&type=template&id=823e1c1c&scoped=true&ts=true"
import script from "./ThreeAxleTractorTwoAxleSemitrailer.vue?vue&type=script&lang=ts"
export * from "./ThreeAxleTractorTwoAxleSemitrailer.vue?vue&type=script&lang=ts"

import "./ThreeAxleTractorTwoAxleSemitrailer.vue?vue&type=style&index=0&id=823e1c1c&scoped=true&lang=css"

import exportComponent from "C:\\BuildAgent\\work\\330398ee0e098db7\\LoadingSokoldok\\Loading\\loading_ui\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-823e1c1c"]])

export default __exports__